const styles = () => ({
  root: {
    listStyle: "none",
    marginBottom: `5px`,
    paddingBottom: "0px !important",
  },
});

export default styles;
